export enum BasketStatus {
    DRAFT = 'draft',
    OPEN = 'open',
    CONFIRMED = 'confirmed'
}

/** Response from `GET /CP/basket/item-lookup/` (basket upload item validation). */
export interface BasketUploadItemLookup {
    item: string;
    quantity: number;
    price: number;
    totalPrice: number;
    currency: string;
    unit: string;
    originalPrice: number;
    isBlocked: boolean;
    item_image?: string | null;
    on_hand?: number | null;
    status: string;
    searchKey1?: string | null;
    minOrderQuantity?: number | null;
    delivery_date?: string | null;
    packedPerQuantity?: string | null;
}

export interface BasketItem {
    id?: any;
    item: string;
    searchKey1 : string;
    quantity: number;
    price: number;
    totalPrice: number;
    currency: string;
    unit: string;
    originalPrice?: number;
    status?: string;
    delivery_date?: Date;
    packedPerQuantity?: string;
    /** When set, ordered quantity must be >= this value */
    minOrderQuantity?: number | null;
    isNotExist?: boolean;
    on_hand?: number | null;
}

export interface Basket {
    updatedAt: any;
    createdAt: any;
    id: number
    user: number;
    name: string;
    status: BasketStatus;
    items: BasketItem[];
    total: number,
    delivery_date?: Date;
    addressCode?: string;
    AddressCode?: string;
    selectedAddressCode?: string;
}